module.exports = __webpack_public_path__ + "static/img/1684_phase_function_Paper_Points.3547763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1684_phase_function_Paper_Points.png
// module id = f7Gh
// module chunks = 0